import { useMutation, useQueryClient } from '@tanstack/react-query';
import { junip } from 'lib/junip';
import type { JunipProductReviewRaw } from 'types/reviews/rawData/JunipProductReviewRaw';

import { PRODUCT_REVIEWS_KEY } from './useProductReviews';

export type VoteDirection = 'up' | 'down';

export interface VoteCounts {
  up: number | null;
  down: number | null;
}

export async function reviewVote(
  reviewId: number,
  voteDirection: VoteDirection,
): Promise<NonNullable<VoteCounts>> {
  const res = await junip<{ product_review: JunipProductReviewRaw }>(
    `/v1/product_reviews/${reviewId}/${voteDirection}_vote`,
    'PUT',
  );

  return {
    up: res.product_review.up_vote_count,
    down: res.product_review.down_vote_count,
  };
}

interface MutationArgs {
  reviewId: number;
  voteDirection: VoteDirection;
}

export const useReviewVote = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ reviewId, voteDirection }: MutationArgs) =>
      reviewVote(reviewId, voteDirection),
    onSuccess: () => {
      queryClient.refetchQueries({
        queryKey: [PRODUCT_REVIEWS_KEY],
      });
    },
  });
};
